import { create } from "zustand";

export type FeedbackSeverity = "success" | "error";
export type FeedbackMode = "dialog" | "snackbar";

type FeedbackState = {
  open: boolean;
  severity: FeedbackSeverity;
  mode: FeedbackMode;
  title: string;
  message: string;
  details?: string;
  showFeedback: (payload: {
    severity: FeedbackSeverity;
    mode?: FeedbackMode;
    title?: string;
    message: string;
    details?: string;
  }) => void;
  closeFeedback: () => void;
};

export const useFeedbackStore = create<FeedbackState>((set) => ({
  open: false,
  severity: "success",
  mode: "snackbar",
  title: "",
  message: "",
  details: undefined,
  showFeedback: ({ severity, mode = severity === "success" ? "snackbar" : "dialog", title, message, details }) =>
    set({
      open: true,
      severity,
      mode,
      title:
        title ||
        (severity === "success" ? "Operação concluída" : "Não foi possível concluir a operação"),
      message,
      details,
    }),
  closeFeedback: () =>
    set({
      open: false,
      details: undefined,
    }),
}));
